import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../axiosConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/NewAuth.css';

const ConfirmAccountDeletion = () => {
    const { t } = useTranslation('auth');
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    const [status, setStatus] = useState('pending');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage(t('deleteAccount.invalidToken'));
        }
    }, [token, t]);

    const handleConfirmDeletion = async () => {
        setStatus('loading');
        try {
            await axios.get(`/api/v1/auth/confirm-account-deletion?token=${token}`);
            setStatus('success');
            setMessage(t('deleteAccount.successMessage'));
            localStorage.removeItem('jwt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('userType');
            setTimeout(() => navigate('/'), 5000);
        } catch (err) {
            setStatus('error');
            setMessage(t('deleteAccount.errorMessage'));
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h1>{t('deleteAccount.title')}</h1>

                {status === 'pending' && (
                    <>
                        <p style={{ marginBottom: '15px', color: '#666' }}>
                            {t('deleteAccount.confirmMessage')}
                        </p>
                        <p style={{ marginBottom: '25px', color: '#e74c3c', fontWeight: '600' }}>
                            {t('deleteAccount.irreversibleWarning')}
                        </p>
                        <button
                            onClick={handleConfirmDeletion}
                            style={{ backgroundColor: '#e74c3c', marginBottom: '10px' }}
                        >
                            {t('deleteAccount.confirmButton')}
                        </button>
                        <button
                            type="button"
                            className="back-btn"
                            onClick={() => navigate('/')}
                        >
                            {t('deleteAccount.cancel')}
                        </button>
                    </>
                )}

                {status === 'loading' && (
                    <p style={{ color: '#666' }}>{t('deleteAccount.deleting')}</p>
                )}

                {status === 'success' && (
                    <>
                        <p className="success-message">{message}</p>
                        <button type="button" className="back-btn" onClick={() => navigate('/')}>
                            {t('deleteAccount.goToLogin')}
                        </button>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <p className="error">{message}</p>
                        <button type="button" className="back-btn" onClick={() => navigate('/')}>
                            {t('deleteAccount.backToHome')}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default ConfirmAccountDeletion;
